import _ from "lodash";

/**
 * Compares the rows a role was loaded with against the rows the form submitted, matching them by
 * their own identity (userId, permissionId, apiKeyId) rather than by a synthetic row key. The form
 * only hands back registered fields, so an existing row is merged over its original before being
 * compared: unchanged rows are then equal and are not sent, and a changed row still carries the
 * fields the request needs (its id, version, name) that the form never registered.
 *
 * A submitted row whose id is not among the originals is new. An original whose id is not among the
 * submitted rows was removed.
 */
export function diffRoleItems(originalItems, modifiedItems, idField) {
    let result = { added: [], deleted: [], updated: [] };
    if (!originalItems || !modifiedItems) {
        return result;
    }
    let originalById = _.keyBy(originalItems.filter(item => item[idField]), idField);
    let seen = new Set();
    for (let modified of modifiedItems) {
        let id = modified[idField];
        let original = id ? originalById[id] : undefined;
        if (!original) {
            result.added.push({ ...modified });
            continue;
        }
        seen.add(id);
        // A registered field the user never touched comes back undefined; that is not a change.
        let merged = { ...original, ..._.omitBy(modified, _.isUndefined) };
        if (!_.isEqual(original, merged)) {
            result.updated.push(merged);
        }
    }
    for (let original of originalItems) {
        if (original[idField] && !seen.has(original[idField])) {
            result.deleted.push(original);
        }
    }
    return result;
}
